import { render, staticRenderFns } from "./CartPaymentsKeyboardCategory.vue?vue&type=template&id=39119216"
import script from "./CartPaymentsKeyboardCategory.vue?vue&type=script&lang=js"
export * from "./CartPaymentsKeyboardCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports